module.exports = __webpack_public_path__ + "img/Speed-Kit-Logo.c8ff417f.svg";